import { EADDRESS_TYPES, OFFER_CONFIG, USAGE_SERVICE_TYPE } from "./constants";

const API_V1 = "api/v1/";
const API_V2 = "api/v2/";
const SIM_SWAP_MS_NAME = "sim-swap/";
const PAYMENTS_SERVICE_MS_NAME = "payments-service/";

const getPublicAuthenticatedEndPoint = (prefixApiVersion?: string) =>
    `${process.env.API_URL}selfcare/${prefixApiVersion ?? ""}${process.env.PUBLIC_ENDPOINT_PREFIX}${
        process.env.SECURED_ENDPOINT_PREFIX
    }`;

const getBillingServicePublicAuthenticatedEndPoint = (prefixApiVersion?: string) =>
    `${process.env.API_URL}selfcare/billing/${prefixApiVersion ?? ""}${process.env.PUBLIC_ENDPOINT_PREFIX}${
        process.env.SECURED_ENDPOINT_PREFIX
    }`;

const getPaymentsPublicAuthenticatedEndPoint = (prefixApiVersion?: string) =>
    `${process.env.API_URL}payments/${prefixApiVersion ?? ""}${process.env.PUBLIC_ENDPOINT_PREFIX}${
        process.env.SECURED_ENDPOINT_PREFIX
    }`;

const getSimSwapPublicAuthenticatedEndpoint = (prefixApiVersion?: string) =>
    `${process.env.API_URL}selfcare/${SIM_SWAP_MS_NAME}${prefixApiVersion ?? ""}${process.env.PUBLIC_ENDPOINT_PREFIX}${
        process.env.SECURED_ENDPOINT_PREFIX
    }`;

const getPaymentsServicePublicAuthenticatedEndpoint = (prefixApiVersion?: string) =>
    `${process.env.API_URL}selfcare/${PAYMENTS_SERVICE_MS_NAME}${prefixApiVersion ?? ""}${
        process.env.PUBLIC_ENDPOINT_PREFIX
    }${process.env.SECURED_ENDPOINT_PREFIX}`;

const getTwoWayAuthPublicAuthenticatedEndPoint = (prefixApiVersion?: string) =>
    `${process.env.API_URL}two_way_validation/${prefixApiVersion ?? ""}${process.env.PUBLIC_ENDPOINT_PREFIX}${
        process.env.SECURED_ENDPOINT_PREFIX
    }`;

const PUBLIC_ENDPOINT = `${process.env.API_URL}selfcare/${process.env.PUBLIC_ENDPOINT_PREFIX}`;

export const GET_VERIFICATION_CODE_ROUTE = `${PUBLIC_ENDPOINT}otp`;

export const getEircodeFinderRoute = (eircode: string) => `${PUBLIC_ENDPOINT}address?eircode=${eircode}`;

export const validateVerificationCodeRoute = (otpUuid?: string) => `${PUBLIC_ENDPOINT}otp/${otpUuid}/validate`;

export const validateMobileNumberPortRoute = (phoneNumber: string) => `${PUBLIC_ENDPOINT}port/operator/${phoneNumber}`;

export const getSimCardsRequestRoute = (searchParams: string) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}sim-cards-requests?${searchParams}`;

export const getSimSwapChargesRoute = (serviceId: number) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}sim-cards/charges?serviceId=${serviceId}`;

export const getOrderSimRoute = () => `${getPublicAuthenticatedEndPoint(API_V1)}sim-cards/order`;

export const getActiveNewSimRoute = () => `${getPublicAuthenticatedEndPoint(API_V1)}sim-cards/activate`;

export const getServiceApiRoute = (serviceId: number) =>
    `${getPublicAuthenticatedEndPoint(API_V2)}services/${serviceId}`;

export const dismissNotificationRoute = (alertId: number) =>
    `${getPublicAuthenticatedEndPoint()}web_notification/${alertId}/dismiss`;

export const getWebNotificationRoute = (pageNumber: number, lang: string) =>
    `${getPublicAuthenticatedEndPoint()}web_notification?page=${pageNumber}&lang=${lang}`;

export const GET_WEB_NOTIFICATION_COUNT_ROUTE = `${getPublicAuthenticatedEndPoint()}web_notification/count`;

export const getBarringRoute = (serviceId: number, lang: string) =>
    `${getPublicAuthenticatedEndPoint()}barring/${serviceId}?lang=${lang}`;

export const postBarringRoute = (serviceId: number) => `${getPublicAuthenticatedEndPoint()}barring/${serviceId}`;

export const UPDATE_ADDRESS_ROUTE = `${getPublicAuthenticatedEndPoint(API_V2)}addresses`;

export const GET_SUBSCRIPTION_LIST_ROUTE = `${getPublicAuthenticatedEndPoint(API_V2)}subscriptions`;

export const GET_SERVICE_LIST_ROUTE = `${getPublicAuthenticatedEndPoint(API_V2)}services`;

export const GET_PORT_IN_SLOT_ROUTE = `${PUBLIC_ENDPOINT}port/time/${OFFER_CONFIG.BRAND}/${OFFER_CONFIG.CHANNEL}`;

export const getPortinRoute = (serviceId: number) =>
    `${getPublicAuthenticatedEndPoint()}rest/port/service/uncompleted/${serviceId}`;

export const PORT_IN_ROUTE = `${getPublicAuthenticatedEndPoint()}rest/port`;

export const getContactPermissionRoute = (permissionGroup: string) =>
    `${getPublicAuthenticatedEndPoint(API_V2)}permissions?permissionGroupEnum=${permissionGroup}`;

export const UPDATE_CONTACT_PERMISSION_ROUTE = `${getPublicAuthenticatedEndPoint(API_V2)}permissions`;

export const getOneOffPaymentHppRoute = (amount?: number) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}hpp/payments${amount ? `?amount=${amount}` : ""}`;

export const downloadBillRoute = (invoiceNumber: number) =>
    `${getBillingServicePublicAuthenticatedEndPoint(API_V1)}invoices/${invoiceNumber}`;

export const updateExpiryDateCardRoute = (cardId: number) =>
    `${getPaymentsServicePublicAuthenticatedEndpoint(API_V1)}payer/card_payment_method/${cardId}/update_expiry_date`;

export const SEND_VERIFICATION_EMAIL_ROUTE = `${PUBLIC_ENDPOINT}send_verification_email`;

export const postRecoverEmailGenerateOtpRoute = (lang: string) =>
    `${PUBLIC_ENDPOINT}recover_email/otp/generate?lang=${lang}`;

export const RECOVER_EMAIL_VALIDATE_OTP_ROUTE = `${PUBLIC_ENDPOINT}recover_email/otp/validate`;

export const GET_ACCOUNT_LIST_ROUTE = `${getPublicAuthenticatedEndPoint(API_V2)}accounts`;

export const GET_CONTACT_DETAILS_ROUTE = `${getPublicAuthenticatedEndPoint(API_V2)}contacts`;

export const getContactAddressRoute = (addressType: EADDRESS_TYPES) =>
    `${getPublicAuthenticatedEndPoint(API_V2)}addresses/${addressType}`;

export const getAdjustmentDetailsRoute = (reference: string) =>
    `${getPublicAuthenticatedEndPoint()}adjustment/${reference}`;

export const CARDS_HPP_ROUTE = `${getPublicAuthenticatedEndPoint(API_V1)}hpp/cards`;

export const PAYER_ROUTE = `${getPaymentsServicePublicAuthenticatedEndpoint(API_V1)}payer`;

export const updateDefaultPaymentMethodRoute = (cardId: number) => `${PAYER_ROUTE}/default_payment_method/${cardId}`;

export const removePaymentCardRoute = (cardId: number) => `${PAYER_ROUTE}/payment_method/${cardId}`;

export const getPaymentDetailsRoute = (paymentCorrelationTransationUuid: string, query: string) =>
    `${getPaymentsServicePublicAuthenticatedEndpoint(API_V1)}payment/${paymentCorrelationTransationUuid}${query}`;

export const getBillHistoryRoute = (accountId: string) =>
    `${getBillingServicePublicAuthenticatedEndPoint(API_V1)}accounts/invoices`;

export const getOfferDetailsOfServiceRoute = (serviceId: number) =>
    `${getPublicAuthenticatedEndPoint()}offer/${serviceId}`;

export const getSimCardRoute = (serviceId: number) =>
    `${getSimSwapPublicAuthenticatedEndpoint(API_V1)}services/${serviceId}/sim-cards`;

export const getOrderListRoute = (searchQuery: string) => `${getPublicAuthenticatedEndPoint()}order${searchQuery}`;

export const RESET_PASSWORD_ROUTE = `${getPublicAuthenticatedEndPoint()}password/reset`;

export const CHANGE_EMAIL_REQUEST_ROUTE = `${getPublicAuthenticatedEndPoint()}change_email/request`;

export const SAVE_NEW_CARD_ROUTE = `${getPublicAuthenticatedEndPoint()}payment/add-card`;

export const getUsageDetailsRoute = (billingPeriod: string, serviceId: number, query: string) =>
    `${getPublicAuthenticatedEndPoint()}usage/service/${billingPeriod}/${USAGE_SERVICE_TYPE}/${serviceId}${query}`;

export const getUsageSummaryRoute = (serviceId: number, billingPeriod: string) =>
    `${getPublicAuthenticatedEndPoint()}usage_summary/service/${billingPeriod}/${USAGE_SERVICE_TYPE}/${serviceId}`;

export const getUsageTypeListRoute = () => `${PUBLIC_ENDPOINT}reference/rating_subtotal_type`;

export const getAccountBalanceApiRoute = (accountId: string) => `${getPublicAuthenticatedEndPoint(API_V1)}balance`;

export const getTransactionHistoryListApiRoute = (accountId: string, query: string) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}balance/summary${query}`;

export const findAddress = (postalCode: string) =>
    `${process.env.API_URL}acquisition-prospects/findAddress/${postalCode}`;

export const getSimReplacePendingRoute = (serviceId: number) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}sim-cards/pending?serviceId=${serviceId}`;

export const IDENTITY_UPLOAD_ROUTE = `${getPublicAuthenticatedEndPoint(API_V1)}profile/identityDocument`;

export const getSimReplacementRoute = (serviceId: number, blockSim: boolean, contactNumber: string) =>
    `${getPublicAuthenticatedEndPoint(
        API_V1
    )}sim-cards/request/sim-swap?serviceId=${serviceId}&blockSim=${blockSim}&contactNumber=${contactNumber}`;

export const IS_ON_COLLECTION_ROUTE = `${getPublicAuthenticatedEndPoint()}collection/is-in-collection`;

export const getInitialiseAddCardRoute = (lang: string) =>
    `${getPaymentsPublicAuthenticatedEndPoint()}payments/initialise/add-card?language=${lang}`;

export const getTerminateNumberDetailsRoute = (subscriptionId: number) =>
    `${getPublicAuthenticatedEndPoint()}termination/request/${subscriptionId}`;

export const postTerminateNumberRoute = (subscriptionId: number) =>
    `${getPublicAuthenticatedEndPoint()}termination/request/${subscriptionId}`;

export const postTerminateNumberCancellationRoute = (subscriptionId: number) =>
    `${getPublicAuthenticatedEndPoint()}termination/request/cancel/${subscriptionId}`;

export const postUploadContactFileRoute = (docType: string, lang: String) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}upload/contactDocument?documentType=${docType}&lang=${lang}`;

export const getInitialiseOnceOffPaymentRoute = (serviceId: number,lang: string) =>
    `${getPaymentsPublicAuthenticatedEndPoint()}payments/initialise/once-off?language=${lang}&serviceId=${serviceId}`;

export const GET_DEFAULT_CARD_ROUTE = `${getPaymentsServicePublicAuthenticatedEndpoint(
    API_V1
)}payer/default_payment_method`;

export const getAddonsRoute = (serviceId: number, lang: string) =>
    `${getPublicAuthenticatedEndPoint()}addons/${serviceId}?lang=${lang}`;

export const getNiusanceCallStatusRoute = (serviceId: number) =>
    `${getPublicAuthenticatedEndPoint()}addons/nuisance/call/${serviceId}`;

export const postNiusanceCallFileRoute = (serviceId: number) =>
    `${getPublicAuthenticatedEndPoint()}addons/nuisance/call/${serviceId}`;

export const postAddonRoute = (serviceId: number) => `${getPublicAuthenticatedEndPoint()}addons/${serviceId}`;

export const getInitialiseOnceOffBalancePaymentRoute = (lang: string, amount: number) =>
    `${getPaymentsPublicAuthenticatedEndPoint()}payments/initialise/balance/once-off?language=${lang}&amount=${amount}`;

export const postFinalisePaymentRoute = (lang: string) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}hpp/payments?lang=${lang}`;

export const postFinaliseResetCreditLimitRoute = (lang: string) =>
    `${getPublicAuthenticatedEndPoint(API_V1)}hpp/payments/credit-limit?lang=${lang}`;

export const postChangeContactNumberSendOtpRoute = (lang: string) =>
    `${getPublicAuthenticatedEndPoint()}change_contact/otp/generate?lang=${lang}`;

export const CHANGE_CONTACT_NUMBER_VALIDATE_OTP = `${getPublicAuthenticatedEndPoint()}change_contact/otp/validate`;

export const postTwoWayAuthResendOtpRoute = (lang: string) =>
    `${getTwoWayAuthPublicAuthenticatedEndPoint()}sendOtp?lang=${lang}`;

export const TWO_WAY_AUTH_VALIDATE_OTP_ROUTE = `${getTwoWayAuthPublicAuthenticatedEndPoint(API_V2)}verifyOtp`;

export const TWO_WAY_AUTH_CHECK_IF_VALIDATED_ROUTE = `${getTwoWayAuthPublicAuthenticatedEndPoint()}checkIfValidated`;
